'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = saveRefs;

var _memoize = require('lodash/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var saversByMap = new WeakMap();

function saveRefs(m, key) {
  var saver = saversByMap.get(m);
  if (!saver) {
    saver = (0, _memoize2.default)(function (key) {
      return function (el) {
        if (el) {
          m.set(key, el);
        } else {
          saver.cache.delete(key);
          m.delete(key);
        }
      };
    });
    saversByMap.set(m, saver);
  }
  return saver(key);
}
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztrQkFRd0IsUTs7QUFOeEI7Ozs7OztBQUlBLElBQU0sY0FBNkQsSUFBSSxPQUFKLEVBQW5FOztBQUVlLFNBQVMsUUFBVCxDQUFrQixDQUFsQixFQUFzQyxHQUF0QyxFQUF1RDtBQUNwRSxNQUFJLFFBQVEsWUFBWSxHQUFaLENBQWdCLENBQWhCLENBQVo7QUFDQSxNQUFJLENBQUMsS0FBTCxFQUFZO0FBQ1YsWUFBUSx1QkFBUTtBQUFBLGFBQU8sY0FBTTtBQUMzQixZQUFJLEVBQUosRUFBUTtBQUNOLFlBQUUsR0FBRixDQUFNLEdBQU4sRUFBVyxFQUFYO0FBQ0QsU0FGRCxNQUVPO0FBQ0wsZ0JBQU0sS0FBTixDQUFZLE1BQVosQ0FBbUIsR0FBbkI7QUFDQSxZQUFFLE1BQUYsQ0FBUyxHQUFUO0FBQ0Q7QUFDRixPQVBlO0FBQUEsS0FBUixDQUFSO0FBUUEsZ0JBQVksR0FBWixDQUFnQixDQUFoQixFQUFtQixLQUFuQjtBQUNEO0FBQ0QsU0FBTyxNQUFNLEdBQU4sQ0FBUDtBQUNEIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyogQGZsb3cgKi9cblxuaW1wb3J0IG1lbW9pemUgZnJvbSAnbG9kYXNoL21lbW9pemUnO1xuXG50eXBlIFJlZkZuID0gKGVsOiA/T2JqZWN0KSA9PiB2b2lkO1xuXG5jb25zdCBzYXZlcnNCeU1hcDogV2Vha01hcDxNYXA8YW55LE9iamVjdD4sIChrZXk6IGFueSkgPT4gUmVmRm4+ID0gbmV3IFdlYWtNYXAoKTtcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc2F2ZVJlZnMobTogTWFwPGFueSxPYmplY3Q+LCBrZXk6IGFueSk6IFJlZkZuIHtcbiAgbGV0IHNhdmVyID0gc2F2ZXJzQnlNYXAuZ2V0KG0pO1xuICBpZiAoIXNhdmVyKSB7XG4gICAgc2F2ZXIgPSBtZW1vaXplKGtleSA9PiBlbCA9PiB7XG4gICAgICBpZiAoZWwpIHtcbiAgICAgICAgbS5zZXQoa2V5LCBlbCk7XG4gICAgICB9IGVsc2Uge1xuICAgICAgICBzYXZlci5jYWNoZS5kZWxldGUoa2V5KTtcbiAgICAgICAgbS5kZWxldGUoa2V5KTtcbiAgICAgIH1cbiAgICB9KTtcbiAgICBzYXZlcnNCeU1hcC5zZXQobSwgc2F2ZXIpO1xuICB9XG4gIHJldHVybiBzYXZlcihrZXkpO1xufVxuIl19


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-save-refs/js/index.js
 ** module id = 384
 ** module chunks = 0
 **/